/** Static options for Course Equivalence (Conventional teaching mode). */
export const COURSE_EQUIVALENCE_OPTIONS = [
	{ value: "na", labelKey: "feature.courseBuilder.courses.courseEquivalence.na" },
	{ value: "matric", labelKey: "feature.courseBuilder.courses.courseEquivalence.matric" },
	{ value: "intermediate", labelKey: "feature.courseBuilder.courses.courseEquivalence.intermediate" },
	{ value: "intermediate_fsc", labelKey: "feature.courseBuilder.courses.courseEquivalence.intermediateFsc" },
	{ value: "intermediate_fa", labelKey: "feature.courseBuilder.courses.courseEquivalence.intermediateFa" },
	{ value: "bachelor", labelKey: "feature.courseBuilder.courses.courseEquivalence.bachelor" },
	{ value: "diploma", labelKey: "feature.courseBuilder.courses.courseEquivalence.diploma" },
	{ value: "certificate", labelKey: "feature.courseBuilder.courses.courseEquivalence.certificate" },
] as const;

export type CourseEquivalenceValue = (typeof COURSE_EQUIVALENCE_OPTIONS)[number]["value"];

const VALID_EQUIVALENCE_VALUES = new Set<string>(
	COURSE_EQUIVALENCE_OPTIONS.map(option => option.value),
);

/** Map API / legacy labels to form select values (e.g. "Matric" → "matric"). */
export function normalizeCourseEquivalence(raw: string | null | undefined): string {
	if (!raw?.trim()) return "";

	const trimmed = raw.trim();
	const lower = trimmed.toLowerCase();
	if (VALID_EQUIVALENCE_VALUES.has(lower)) return lower;

	const underscored = lower.replace(/[\s-]+/g, "_");
	if (VALID_EQUIVALENCE_VALUES.has(underscored)) return underscored;

	const aliases: Record<string, CourseEquivalenceValue> = {
		n_a: "na",
		"not_applicable": "na",
		matriculation: "matric",
		inter: "intermediate",
		fsc: "intermediate_fsc",
		fa: "intermediate_fa",
		bs: "bachelor",
		bachelors: "bachelor",
	};

	if (aliases[underscored]) return aliases[underscored];

	// Preserve unknown values so data is not dropped on revise; select may show placeholder until matched.
	return underscored;
}
